// import axios from "axios";
import React, { useContext, useRef, useState } from "react";
import "../../styles/globals.scss";
import CustomSwiperItem from "../../components/shared/SwiperCustomComponent/CustomSwiperItem";
import "../../components/shared/SwiperCustomComponent/CustomSwiper.scss";
import "./styles.scss";
import ProductContext from "../shared/contexts/ProductContext";
import clsx from "clsx";

const OneProduct = ({ isImageOnly, isBigItem }) => {
  const [expand, setExpand] = useState(true);
  let onProductRef = useRef(null);
  const context = useContext(ProductContext);

  // const scrollToRef = (elementRef) => {
  //   window.scrollTo({
  //     top: elementRef?.current?.offsetTop - 150,
  //     behavior: "smooth",
  //   });
  // };

  const item = !!context?.oneProduct?.product[0]
    ? context?.oneProduct?.product[0]
    : !!context?.oneProduct
    ? context?.oneProduct
    : !!context?.promotion_link
    ? context
    : null;

  // useEffect(() => {
  //   if (isBigItem) {
  //     scrollToRef(onProductRef);
  //   }
  // }, [onProductRef, item, isBigItem]);

  if (item === undefined || item === null) return null;

  const handleExpand = () => {
    setExpand(true);
    // scrollToRef(onProductRef);
  };
  const handleCollapse = () => {
    setExpand(false);
    // scrollToRef(onProductRef);
  };
  // console.log("item", item);
  return (
    <div
      ref={onProductRef}
      className={clsx("CustomSwiperItemWrap", expand ? "collapse" : "expand")}
    >
      {isBigItem && (
        <div className="top-tools">
          {expand && (
            <div className="checkout-btn" onClick={() => handleCollapse()}>
              Expand
            </div>
          )}
          {!expand && (
            <div className="checkout-btn" onClick={() => handleExpand()}>
              Collapse
            </div>
          )}
        </div>
      )}
      <CustomSwiperItem
        className="OneProduct"
        hasLink
        isBigItem={isBigItem}
        isImageOnly={isImageOnly}
        productId={item?.product_id}
        link={
          !!context?.generateLink ? context?.generateLink : item?.promotion_link
        }
        image={item?.product_main_image_url}
        smallThumbs={item?.product_small_image_urls?.string}
        title={item?.product_title}
        imageAlt={!!item?.product_title ? item?.product_title : "no title"}
        category1={item?.first_level_category_name}
        currency={item?.app_sale_price_currency}
        originaPrice={item?.original_price}
        salePrice={item?.sale_price}
        videoUrl={item?.product_video_url}
      />
      {isBigItem && (
        <div className="top-tools">
          {!expand && (
            <div className="checkout-btn" onClick={() => handleExpand()}>
              Collapse
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default OneProduct;
